var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2393 3L9.23926 15V33C9.23926 49.65 20.7593 65.22 36.2393 69C51.7193 65.22 63.2393 49.65 63.2393 33V15L36.2393 3Z",
    fill: "#E9ECEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeIcon);
export default __webpack_public_path__ + "static/media/BadgeIcon.ea3369509bdfa7a1c80ee0ec6f80c6f6.svg";
export { ForwardRef as ReactComponent };